/**
 * 카드 로그인 에러 코드에 따른 에러 메시지 반환
 */
export const getCardLoginErrorMessage = (errorCode: string) => {
  switch (errorCode) {
    case 'INVALID_ID_OR_PASSWORD':
      return '아이디 또는 비밀번호가 올바르지 않습니다';
    case 'INVALID_ID':
      return '아이디가 올바르지 않습니다';
    case 'INVALID_PASSWORD':
      return '비밀번호가 올바르지 않습니다';
    case 'TRY_LIMIT_EXCEED':
      return '로그인 시도 횟수를 초과하셨습니다. 카드사 홈페이지에서 확인해주세요';
    case 'ALREADY_CONNECTED':
      return '이미 연동된 계정입니다';
    default:
      return '카드사 연동 중 오류가 발생했습니다';
  }
};
